import GeneralIcon from './Images/GeneralIcon.png';
import AdminConsoleIcon from './Images/AdminConsoleIcon.png';
import ProtectedDomainsIcon from './Images/ProtectedDomainsIcon.png';
import SilverfortNodesIcon from './Images/SilverfortNodesIcon.png';
import MfaTokensIcon from './Images/MfaTokensIcon.png';
import DesktopApplicationsIcon from './Images/DesktopApplicationsIcon.png';
import IntegrationsIcon from './Images/IntegrationsIcon.png';
import AssetsIcons from './Images/assets_icon.svg';
import SilverfortApiIcon from './Images/SilverfortApiIcon.png';
import CustomInsightsIcon from './Images/CustomInsightsIcon.png';
import AdvancedIcon from './Images/AdvancedIcon.png';
import LicenseIcon from './Images/LicenseIcon.png';
import AlertsManagementIcon from './Images/notifications_active.svg';
import AvailabilityZonesIcon from './Images/AvailabilityZonesIcon.png';
import CloudIntegrationsIcon from './Images/CloudIntegrations.svg';

export const CATEGORIES = {
    GENERAL: {
        ID: 'general',
        NAME: 'General',
        ICON: GeneralIcon
    },
    SECURITY: {
        ID: 'security',
        NAME: 'Admin Console',
        ICON: AdminConsoleIcon
    },
    PROTECTED_DOMAINS: {
        ID: 'protectedDomains',
        NAME: 'Protected Domains',
        ICON: ProtectedDomainsIcon,
        SORT_TABS: true
    },
    SILVERFORT_NODES: {
        ID: 'silverfortNodes',
        NAME: 'Silverfort Nodes',
        ICON: SilverfortNodesIcon,
        SORT_TABS: true
    },
    AVAILABILITY_ZONES: {
        ID: 'availabilityZones',
        NAME: 'Availability Zones',
        ICON: AvailabilityZonesIcon,
        SORT_TABS: true
    },
    MFA_TOKENS: {
        ID: 'mfaTokens',
        NAME: 'MFA Tokens',
        ICON: MfaTokensIcon
    },
    USER_MANAGEMENT: {
        ID: 'userManagement',
        NAME: 'MFA User Management',
        ICON: MfaTokensIcon // todo: get icon from Sarai
    },
    DESKTOP_APPLICATION: {
        ID: 'desktopApplication',
        NAME: 'Desktop Application',
        ICON: DesktopApplicationsIcon
    },
    INTEGRATIONS: {
        ID: 'integrations',
        NAME: 'Integrations',
        ICON: IntegrationsIcon
    },
    CLOUD_INTEGRATIONS: {
        ID: 'cloudIntegrations',
        NAME: 'Cloud Integrations',
        ICON: CloudIntegrationsIcon
    },
    PRIVILEGED_ACCESS: {
        ID: 'privilegedAccessSecurity',
        NAME: 'Privileged Access',
        ICON: AssetsIcons
    },
    NON_HUMAN_IDENTITIES: {
        ID: 'NonHumanIdentities',
        NAME: 'Non-Human Identities',
        ICON: AssetsIcons
    },
    SILVERFORT_API: {
        ID: 'silverfortApi',
        NAME: 'Silverfort API',
        ICON: SilverfortApiIcon
    },
    CUSTOM_INSIGHTS: {
        ID: 'customInsights',
        NAME: 'Custom Insights',
        ICON: CustomInsightsIcon
    },
    ADVANCED: {
        ID: 'advanced',
        NAME: 'Advanced',
        ICON: AdvancedIcon
    },
    LICENSING: {
        ID: 'licensing',
        NAME: 'Licensing',
        ICON: LicenseIcon
    },
    ALERTS_MANAGEMENT: {
        ID: 'alertsManagement',
        NAME: 'Notifications',
        ICON: AlertsManagementIcon
    }
};

export const SUBCATEGORIES = {
    COMPANY_INFO: {
        ID: 'companyInfo',
        NAME: 'Company Info'
    },
    SYSLOG_SERVER: {
        ID: 'syslogServers',
        NAME: 'Syslog'
    },
    RADIUS_CLIENTS: {
        ID: 'radiusClients',
        NAME: 'RADIUS Clients'
    },
    SMTP_SERVER: {
        ID: 'smtpServer',
        NAME: 'SMTP Server'
    },
    FAIL_CLOSE: {
        ID: 'failClose',
        NAME: 'Fail Close'
    },
    SELECTIVE_FORWARDING: {
        ID: 'selectiveForwarding',
        NAME: 'Selective Forwarding'
    },
    SECURITY_MAIN: {
        ID: 'securityMain',
        NAME: 'Main'
    },
    ADMIN_SECURITY_ROLES: {
        ID: 'adminSecurityRoles',
        NAME: 'Security Roles'
    },
    PROTECTED_DOMAINS: {
        ID: 'protectedDomainsSub',
        NAME: 'Protected Domains'
    },
    SILVERFORT_NODES: {
        ID: 'silverfortNodesSub',
        NAME: 'Silverfort Nodes'
    },
    DUO_MFA_TOKEN: {
        ID: 'duoMfaToken',
        NAME: 'DUO'
    },
    RSA_MFA_TOKEN: {
        ID: 'rsaMfaToken',
        NAME: 'RSA'
    },
    OKTA_MFA_TOKEN: {
        ID: 'oktaMfaToken',
        NAME: 'Okta'
    },
    PING_MFA_TOKEN: {
        ID: 'pingMfaToken',
        NAME: 'Ping'
    },
    MICROSOFT_MFA_TOKEN: {
        ID: 'microsoftMfaToken',
        NAME: 'Microsoft'
    },
    ENTRA_ID_MFA_TOKEN: {
        ID: 'entraIdMfaToken',
        NAME: 'Entra ID'
    },
    HYPR_MFA_TOKEN: {
        ID: 'hyprMfaToken',
        NAME: 'HYPR'
    },
    FIDO2_MFA_TOKEN: {
        ID: 'fido2MfaToken',
        NAME: 'FIDO2'
    },
    APPLICATION_SETTINGS: {
        ID: 'applicationSettings',
        NAME: 'Application Settings'
    },
    DESKTOP_MESSAGING_SERVICES: {
        ID: 'desktopMessagingServices',
        NAME: 'Desktop Messaging Services'
    },
    DESKTOP_NOTIFICATION: {
        ID: 'desktopNotification',
        NAME: 'Customize Notification'
    },
    OTP_NOTIFICATION: {
        ID: 'otpNotification',
        NAME: 'Customize MFA Prompt'
    },
    ADFS_FEDERATED_APPS: {
        ID: 'adfsFederatedApps',
        NAME: 'ADFS Apps'
    },
    PING_FEDERATED_APPS: {
        ID: 'pingFederatedApps',
        NAME: 'PingFederate Apps'
    },
    AZURE_CONNECTORS: {
        ID: 'azureConnectors',
        NAME: 'Entra ID'
    },
    NEW_AZURE_CONNECTORS: {
        ID: 'newAzureConnectors',
        NAME: 'Entra ID'
    },
    OKTA_CONNECTORS: {
        ID: 'oktaConnectors',
        NAME: 'Okta Connectors'
    },
    AUTH_TOKENS_AND_USERS: {
        ID: 'authTokensAndUsers',
        NAME: 'API Keys'
    },
    ADFS_AND_MFA: {
        ID: 'adfsAndMfa',
        NAME: 'ADFS & MFA'
    },
    PRIVILEGED_ACCOUNTS: {
        ID: 'privilegedAccounts',
        NAME: 'Privileged Access'
    },
    SERVICE_ACCOUNTS: {
        ID: 'serviceAccounts',
        NAME: 'Service Accounts'
    },
    MAINTENANCE: {
        ID: 'maintenance',
        NAME: 'Maintenance'
    },
    SSO_CONFIG: {
        ID: 'ssoConfig',
        NAME: 'SSO Config'
    },
    ADVANCED_CONFIG: {
        ID: 'advancedConfig',
        NAME: 'Console & Nodes Config',
        SAAS_SUPPORT_NAME: 'Console Config'
    },
    ELASTIC_CONFIG: {
        ID: 'elasticConfig',
        NAME: 'Elastic Config'
    },
    LICENSE: {
        ID: 'license',
        NAME: 'License'
    },
    MOBILE_MESSAGING_SERVICES: {
        ID: 'mobileMessagingServices',
        NAME: 'Mobile Messaging Services'
    },
    AVAILABILITY_ZONES: {
        ID: 'availabilityZonesSub',
        NAME: 'Availability Zones'
    },
    SF_SUPPORT: {
        ID: 'silverfortSupport',
        NAME: 'Support'
    },
    WEBHOOK: {
        ID: 'webhook',
        NAME: 'Webhook'
    },
    CUSTOM_INTEGRATIONS: {
        ID: 'CustomIntegrations',
        NAME: 'Custom'
    },
    SSO_APPS: {
        ID: 'ssoApps',
        NAME: 'Identity Bridge'
    },
    RESOURCES: {
        ID: 'tiersConfig',
        NAME: 'Resources'
    },
    JIT: {
        ID: 'jitCustomSettings',
        NAME: 'JIT'
    },
    EMAIL: {
        ID: 'email',
        NAME: 'Email'
    },
    ACCOUNT_MATCHING: {
        ID: 'accountMatching',
        NAME: 'Account Matching'
    },
    ENROLLMENT_SETTINGS: {
        ID: 'enrollmentSettings',
        NAME: 'Enrollment Settings'
    },
    NHI_ON_PREM: {
        ID: 'onPrem',
        NAME: 'Active Directory'
    }
};
